// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"48ec3d27","455":"785d8089","977":"f84bf5bd"}[chunkId] + ".chunk.js";
};